import Decorator from 'clientDecorator';
import PropTypes from 'prop-types';
import Avatar from 'components/elements/avatar';
import { Link, LinkButton } from '@evertrue/et-components';
import EllipsisOverflow from 'components/formatting/ellipsis-overflow';
import {
  getRemoteIdBackgroundColor,
  getPhoneBackgroundColor,
  getEmailBackgroundColor,
} from '../config/query-highlight-utilities';

const GlobalSearchContactCard = ({ contact = {}, query = '', queryType = 'all', children }) => {
  const renderNameFromGql = (contact) => {
    return contact?.contact_attributes?.name_full;
  };

  const formattedName =
    Decorator.Contacts.getDetailedName(contact, { include_middle: true }) ||
    contact?.name ||
    renderNameFromGql(contact);

  const remoteId = contact.identities?.find((id) => id.type === 'remote_id')?.value || '';
  const phones = contact.phones?.map((phone) => phone.phone?.value);
  const emails = contact.emails?.map((email) => email.email?.value);

  return (
    <div className="new-contact-card">
      <div className={`new-contact-card--body ${contact.isStacked ? 'is-stacked' : ''}`}>
        <Link
          href={`/contact/${contact?.id}`}
          target="_blank"
          title={`${contact.name}'s Profile`}
          data-refer="global-search"
        >
          <Avatar
            url={contact?.avatar || contact?.avatar_url || ''}
            className="new-contact-card--avatar fs-exclude-data"
            name={formattedName}
            width={40}
          />
        </Link>
        <div
          className="new-contact-card--content"
          style={{
            width: 'calc(100% - 40px)',
            verticalAlign: 'middle',
          }}
        >
          <LinkButton className={`new-contact-card--name ${contact.properties?.deceased?.value ? 'is-deceased' : ''}`}>
            <strong className="fs-exclude-data">{formattedName}</strong>
            {contact.properties?.deceased?.value && (
              <span className="new-contact-card--deceased fs-exclude-data">Deceased</span>
            )}
          </LinkButton>

          <EllipsisOverflow className="new-contact-card--class fs-exclude-data">
            <strong>{Decorator.Profile.getRoleWithYear(contact)}</strong>
          </EllipsisOverflow>

          {remoteId && (
            <div
              style={getRemoteIdBackgroundColor(remoteId, query, queryType)}
              className="new-contact-card--highlighted fs-exclude-data"
            >
              <strong>Remote ID:</strong> {remoteId}
            </div>
          )}

          {phones && queryType === 'phone' && (
            <div className="new-contact-card--highlighted fs-exclude-data">
              <strong>Phones:</strong>{' '}
              {phones.map((phone) => (
                <div style={getPhoneBackgroundColor(phone, query, queryType)} key={phone}>
                  {phone}
                </div>
              ))}
            </div>
          )}

          {emails && (queryType === 'email' || queryType === 'all') && (
            <div className="new-contact-card--highlighted fs-exclude-data">
              <strong>Emails:</strong>{' '}
              {emails.map((email) => (
                <div style={getEmailBackgroundColor(email, query, queryType)} key={email}>
                  {email}
                </div>
              ))}
            </div>
          )}

          <div className="new-contact-card--children">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default GlobalSearchContactCard;

GlobalSearchContactCard.propTypes = {
  contact: PropTypes.object.isRequired,
  query: PropTypes.string.isRequired,
  queryType: PropTypes.string.isRequired,
  children: PropTypes.node,
};
